import { __decorate, __metadata } from "tslib";
import { containerResolver } from '../protocol/resolver';
/**
 * Used to allow functions/classes to specify lazy resolution logic.
 */
var LazyResolver = /** @class */ (function () {
    /**
     * Creates an instance of the Lazy class.
     * @param key The key to lazily resolve.
     */
    function LazyResolver(key) {
        this._key = key;
    }
    LazyResolver_1 = LazyResolver;
    /**
     * Creates a Lazy Resolver for the supplied key.
     * @param key The key to lazily resolve.
     * @return Returns an instance of Lazy for the key.
     */
    LazyResolver.of = function (key) {
        return new LazyResolver_1(key);
    };
    /**
     * Called by the container to lazily resolve the dependency into a lazy locator function.
     * @param container The container to resolve from.
     * @return Returns a function which can be invoked at a later time to obtain the actual dependency.
     */
    LazyResolver.prototype.get = function (container) {
        var _this = this;
        return function () { return container.get(_this._key); };
    };
    var LazyResolver_1;
    LazyResolver = LazyResolver_1 = __decorate([
        containerResolver,
        __metadata("design:paramtypes", [Object])
    ], LazyResolver);
    return LazyResolver;
}());
export { LazyResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGF6eVJlc29sdmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiTGF6eVJlc29sdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFPQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUd6RDs7R0FFRztBQUVIO0lBWUk7OztPQUdHO0lBQ0gsc0JBQW1CLEdBQVc7UUFDMUIsSUFBSSxDQUFDLElBQUksR0FBRyxHQUFHLENBQUM7SUFDcEIsQ0FBQztxQkFsQlEsWUFBWTtJQUNyQjs7OztPQUlHO0lBQ1csZUFBRSxHQUFoQixVQUFvQixHQUFXO1FBQzNCLE9BQU8sSUFBSSxjQUFZLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDakMsQ0FBQztJQVlEOzs7O09BSUc7SUFDSSwwQkFBRyxHQUFWLFVBQVcsU0FBb0I7UUFBL0IsaUJBRUM7UUFERyxPQUFPLGNBQU0sT0FBQSxTQUFTLENBQUMsR0FBRyxDQUFDLEtBQUksQ0FBQyxJQUFJLENBQUMsRUFBeEIsQ0FBd0IsQ0FBQztJQUMxQyxDQUFDOztJQTNCUSxZQUFZO1FBRHhCLGlCQUFpQjs7T0FDTCxZQUFZLENBNEJ4QjtJQUFELG1CQUFDO0NBQUEsQUE1QkQsSUE0QkM7U0E1QlksWUFBWSJ9